export const VIEW_NAVIGATION_BAR = 'view_navigation_bar';
export const VIEW_COMMISSAR_ANSWER = 'view_commissar_answer';
